export default "__VITE_ASSET__CAU1q8Jy__"